module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Clothes/Dress-d031232ebfde377cbe37d7c8a223a146.svg";